import { useQuery, UseQueryResult } from 'react-query';
import { fetchCompanyFilingsTypes } from '../../services/companyFilings/companyFilings.service';
import { CompanyFilingsTypeDto } from '../../services/dtos/companyFilings/companyFilingsType.dto';
import { queryKeys } from '../queryKeyFactory';

export default (): UseQueryResult<CompanyFilingsTypeDto[], Error> =>
  useQuery(queryKeys.fetchFilings.types, () => fetchCompanyFilingsTypes());
